const MAX_LICENSE_GRANT_QUANTITY = 500000;
const MAX_FI_GRANT_QUANTITY = 999999999;

export {MAX_LICENSE_GRANT_QUANTITY, MAX_FI_GRANT_QUANTITY};
